import { createFileRoute } from '@tanstack/react-router'
import { NotFoundComponent } from './-components/ErrorPages/NotFound.tsx'

export const Route = createFileRoute('/not-found')({
  component: RouteComponent
})

function RouteComponent() {
  return <NotFoundComponent />
}
